import * as XLSX from "xlsx";

const ISO = /^(\d{4})-(\d{2})-(\d{2})$/;
const BR = /^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/;

function paraIso(ano: number, mes: number, dia: number): string | null {
  const d = new Date(Date.UTC(ano, mes - 1, dia));
  if (d.getUTCFullYear() !== ano || d.getUTCMonth() !== mes - 1 || d.getUTCDate() !== dia) return null;
  return `${String(ano).padStart(4, "0")}-${String(mes).padStart(2, "0")}-${String(dia).padStart(2, "0")}`;
}

// Converte o valor de uma célula de data da planilha para AAAA-MM-DD, o que o backend recebe.
// Aceita DD/MM/AAAA, DD-MM-AAAA, AAAA-MM-DD e o número serial que o Excel guarda numa
// célula formatada como data. Vazio devolve ""; valor que não é data válida devolve null.
export function normalizarData(valor: unknown): string | null {
  if (valor === null || valor === undefined) return "";
  if (typeof valor === "number") {
    const p = XLSX.SSF.parse_date_code(valor);
    return p ? paraIso(p.y, p.m, p.d) : null;
  }
  const texto = String(valor).trim();
  if (texto === "") return "";
  const iso = ISO.exec(texto);
  if (iso) return paraIso(Number(iso[1]), Number(iso[2]), Number(iso[3]));
  const br = BR.exec(texto);
  if (br) return paraIso(Number(br[3]), Number(br[2]), Number(br[1]));
  return null;
}
